// @flow

import React from "react";

import { BASE_PATH } from "../../constants";

const LOGIN_URL = `${BASE_PATH}/login`;

export function LoginLink(props: {
    id?: string,
    className?: string,
    children: any
}) {
    return (
        <a
            id={props.id}
            className={props.className || ""}
            href={LOGIN_URL}
            onClick={reloadLoginPage}
        >
            {props.children}
        </a>
    );
}

function reloadLoginPage(e: Event) {
    e.preventDefault();
    window.location.assign(LOGIN_URL);
}
